module.exports = __webpack_public_path__ + "img/30.000ea624.jpg";